import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AttemptType, OrderingType } from 'src/config/api/models/Score';

export interface DashboardSettingsState {
  selectedAttempFilter: AttemptType;
  selectedOrderingFilter: OrderingType;
  isSidebarOpen: boolean;
}

const initialState: DashboardSettingsState = {
  selectedAttempFilter: 'best',
  selectedOrderingFilter: 'leerling',
  isSidebarOpen: false,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setSelectedAttemptFilter(state, action: PayloadAction<AttemptType>) {
      state.selectedAttempFilter = action.payload;
    },
    setSelectedOrderingFilter(state, action: PayloadAction<OrderingType>) {
      state.selectedOrderingFilter = action.payload;
    },
    setIsSidebarOpen(state, action: PayloadAction<boolean>) {
      state.isSidebarOpen = action.payload;
    },
    closeSidebar(state) {
      state.isSidebarOpen = false;
    },
    toggleSidebar(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
  },
});

export const {
  setSelectedAttemptFilter,
  setSelectedOrderingFilter,
  setIsSidebarOpen,
  closeSidebar,
  toggleSidebar,
} = dashboardSlice.actions;

export const { reducer: dashboardReducer } = dashboardSlice;
